export interface StudioData {
    str_id?: number,
    str_name?: string,
    std_id?: number,
    std_name?: string,
    std_area?: string,
    stdimg_id?: number,
    sort?: number,
    operation_end_date?: Date,
    operation_start_date?: Date,
}

export interface ObjectToStudioDataProps {
    str_id: string | number,
    str_name: string,
    std_id: string | number,
    std_name: string,
    std_area?: string,
    stdimg_id: string | number,
    sort: string | number,
    operation_end_date?: string,
    operation_start_date?: string,
}
export const ObjectToStudioData = ({
    str_id,
    str_name,
    std_id,
    std_name,
    std_area,
    stdimg_id,
    sort,
    operation_end_date,
    operation_start_date,
}: ObjectToStudioDataProps): StudioData => {
    return {
        str_id: typeof str_id == 'number' ? str_id : parseInt(str_id),
        str_name: str_name,
        std_id: typeof std_id == 'number' ? std_id : parseInt(std_id),
        std_name: std_name,
        std_area: std_area,
        stdimg_id: typeof stdimg_id == 'number' ? stdimg_id : parseInt(stdimg_id),
        sort: typeof sort == 'number' ? sort : parseInt(sort),
        operation_end_date: operation_end_date ? new Date(operation_end_date) : undefined,
        operation_start_date: operation_start_date ? new Date(operation_start_date) : undefined,
    }
}